import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController } from 'ionic-angular';
import { ExtraProvider } from '../../providers/extra/extra';
import { ToastProvider } from '../../providers/toast/toast';
import { PopoverPage } from '../popover/popover';
import { AddMemberPage } from '../add-member/add-member';
import { LoginProvider } from '../../providers/login/login';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-members',
  templateUrl: 'members.html',
})
export class MembersPage {

  members = [];
  showData = false;
  permissions: any;
  selRegistrationLogin  : any;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private extraProvider: ExtraProvider,
    private toast: ToastProvider,
    private translate: TranslateService,
    private popoverCtrl: PopoverController,
    private login: LoginProvider) {

      this.selRegistrationLogin = localStorage.getItem('signup_login')

      if(this.selRegistrationLogin){
        this.showData = true
        this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
      }
else{
    extraProvider.getMembers().then(val => {
      if(val.status == "success"){
        this.members = val.data;
      }else{
        toast.presentToast(val.message);
      }
      this.showData = true;
    });

    login.getUserDetails().then(val => {
      this.permissions = val.permissions;
    });
  }
  }

  deleteMember(member){
    this.extraProvider.deleteMember(member).then(val => {
      if(val.status == "success"){
        this.refresh();
      }
      this.toast.presentToast(val.message);
    })
  }

  refresh(){
    this.showData = false;
    this.extraProvider.getMembers().then(val => {
      if(val.status == "success"){
        this.members = val.data;
      }else{
        this.members = [];
        this.toast.presentToast(val.message);
      }
      this.showData = true;
    });
  }

  addMember(){
    this.navCtrl.push(AddMemberPage,{
      parentPage: this
    });
  }

  editMember(member){
    console.log(member);
    this.navCtrl.push(AddMemberPage,{
      data: member,
      parentPage: this
    });
  }

  presentPopover(myEvent, item) {
    let popover = this.popoverCtrl.create(PopoverPage, {
      parentPage: this,
      options: [
        {
          title: this.translate.instant("DELETE"),
          handler: function(that){
            that.deleteMember(item);
          }
        },
        {
          title: this.translate.instant("EDIT"),
          handler: function(that){
            that.editMember(item);
          }
        },
      ]
    });
    popover.present({
      ev: myEvent
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MembersPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/members/members.ts